import React from 'react'
import { submit } from 'redux-form';
import { SaveButton } from '../../../itrust_common/components/others';

export default function AppointmentModalHeader(props) {
  const { appointmentEditing, handleAppointmentEditCancel, activeTourType, appointment, formType, handleAppointmentEditHandler, handleAppointmentReconfirm, handleAppointmentDelete, saving, dispatch, isTourActive, isTabLogs } = props
  return (
    <>
      <h6 className="modal-title">
        {appointmentEditing.id === "New" ? 'Create Appointment' : 'Edit Appointment'}
      </h6>
      <div className="d-flex flex-row">
        {activeTourType !== 'appointment' && <button type="button" className="btn btn-outline-primary mr-4" onClick={() => handleAppointmentEditCancel()}>Cancel</button>}
        {!appointment.id ?
          formType === 'default' ?
            <button className="btn btn-outline-primary mr-4" onClick={() => handleAppointmentEditHandler({ formType: 'new' })}><i className='la la-plus mr-2 font-size-16'></i>Add New Patient</button> :
            !isTourActive && <button type="button" className="btn btn-outline-primary mr-4" onClick={() => { handleAppointmentEditHandler({ isFullMode: true }); }}>
              Full Mode
            </button> :
          <div className="dropdown">
            <button type="button" className="btn btn-outline-primary dropdown-toggle mr-4" data-toggle="dropdown">
              More Options
            </button>
            <div className="dropdown-menu py-1 border-0 rounded shadow">
              {!isTabLogs && <a className="dropdown-item pointer"
                onClick={() => { handleAppointmentEditHandler({ isFullMode: true }); }}>
                Full mode
              </a>}
              <a className="dropdown-item" onClick={() => handleAppointmentReconfirm(appointment.id)}>Reconfirm</a>
              <a className="dropdown-item pointer" onClick={() => handleAppointmentDelete(appointment.id)}>Cancel</a>
            </div>
          </div>
        }
        <SaveButton buttonClasses={`${(appointmentEditing.id === "New" && formType === 'default') && 'disabled'}`} saving={saving} handleOnClick={() => dispatch(submit('appointmentForm'))} />
      </div>
    </>
  )
}
